const { serialize } = require("../../utils");
export default {
  namespaced: true,
  state: {
    path: "aljabr/examinations",
  },
  actions: {
    getGroups({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/getGroups?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    getGroupsForExam({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/getGroupsForExam?${serialize(data)}`,
          method: "GET",
          data: data,
        },
        { root: true }
      );
    },
    getSciencesForExam({ dispatch, state, rootState }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/getSciencesForExam`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    getSubjects({ dispatch, state, rootState }) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/getSubjects`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    create({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/create`,
          method: "POST",
          data: data,
        },
        { root: true }
      );
    },
    getStudents({ dispatch, state, rootState }, groupId) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/getStudents/${groupId}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    saveResults({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/saveResults`,
          method: "POST",
          data: data,
        },
        { root: true }
      );
    },
  },
};
